import {VideoSlidesStreamJackpotContainerDefaultBox} from "./video-slides-stream-jackpot-container-default.box"

export const VideoSlidesStreamJackpotContainerBox = VideoSlidesStreamJackpotContainerDefaultBox;